
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("ar6Ga", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $3gadb = parcelRequire("3gadb");


var $1yB28 = parcelRequire("1yB28");


var $9x2sR = parcelRequire("9x2sR");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $ep3mz = parcelRequire("ep3mz");

const $32b09d763047f808$export$df735ef660bb40ec = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { onClick: onClick, isLegacy: isLegacy } = t0;
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const isSelected = (0, $dPJCf.useRouteName)(isLegacy ? $32b09d763047f808$var$isOnLegacySpaceQuestionsRoute : $32b09d763047f808$var$isOnSpaceQuestionsRoute);
    let t1;
    if ($[0] !== isLegacy || $[1] !== spaceKey) {
        t1 = isLegacy ? (0, $1NBp8.SPACE_QUESTIONS).toUrl({
            spaceKey: spaceKey
        }) : (0, $1NBp8.SPACE_QUESTIONS_NATIVE).toUrl({
            spaceKey: spaceKey
        });
        $[0] = isLegacy;
        $[1] = spaceKey;
        $[2] = t1;
    } else t1 = $[2];
    const href = t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $32b09d763047f808$var$i18n.questionsTooltip);
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
            label: "",
            color: "currentColor"
        });
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $32b09d763047f808$var$i18n.questions);
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== href || $[7] !== isSelected || $[8] !== onClick) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            position: "top",
            content: t2
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
            href: href,
            onClick: onClick,
            elemBefore: t3,
            isSelected: isSelected
        }, t4));
        $[6] = href;
        $[7] = isSelected;
        $[8] = onClick;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : ({ onClick: onClick, isLegacy: isLegacy })=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const isSelected = (0, $dPJCf.useRouteName)(isLegacy ? $32b09d763047f808$var$isOnLegacySpaceQuestionsRoute : $32b09d763047f808$var$isOnSpaceQuestionsRoute);
    const href = isLegacy ? (0, $1NBp8.SPACE_QUESTIONS).toUrl({
        spaceKey: spaceKey
    }) : (0, $1NBp8.SPACE_QUESTIONS_NATIVE).toUrl({
        spaceKey: spaceKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        position: "top",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $32b09d763047f808$var$i18n.questionsTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
        href: href,
        onClick: onClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
            label: "",
            color: "currentColor"
        }),
        isSelected: isSelected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $32b09d763047f808$var$i18n.questions)));
};
const $32b09d763047f808$var$isOnSpaceQuestionsRoute = {
    selector: (routeName)=>routeName === (0, $1NBp8.SPACE_QUESTIONS_NATIVE).name
};
const $32b09d763047f808$var$isOnLegacySpaceQuestionsRoute = {
    selector: (routeName)=>routeName === (0, $1NBp8.SPACE_QUESTIONS).name
};
const $32b09d763047f808$var$i18n = (0, $cgtv4.defineMessages)({
    questions: {
        id: "side-navigation.space-navigation.questions",
        defaultMessage: "Questions"
    },
    questionsTooltip: {
        id: "side-navigation.space-navigation.questions.tooltip",
        defaultMessage: "Ask and answer questions for this space"
    }
});
module.exports["QuestionsLink"] = $32b09d763047f808$export$df735ef660bb40ec;

});


//# sourceMappingURL=QuestionsLink.0f3d0056.js.map
